<div class="card-container-shadow">
  <div class="name">
    <p class="text-title-md line-height-normal pr-xlg" nz-popover nzPopoverTitle="" [nzPopoverContent]="foodGroup.name">{{ foodGroup.name }}</p>
    <div class="more-options">
      <div *ngIf="!foodGroup.official" nz-popover="" nzPopoverTitle="" nzPopoverContent="Modificar" class="icon-action tw-mr-2" (click)="onEmitModify()">
        <i nz-icon nzType="edit" nzTheme="outline"></i>
      </div>
      <div *ngIf="foodGroup.official" nz-popover="" nzPopoverTitle="" nzPopoverContent="Las recetas originales Dèliè no se pueden modificar ni eliminar, solo pueden duplicarse." class="icon-action tw-mr-2">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
      </div>
      <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Duplicar" class="icon-action tw-mr-2" (click)="onEmitClone()">
        <i nz-icon nzType="copy" nzTheme="outline"></i>
      </div>
      <div *ngIf="!foodGroup.official" nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onEmitDelete()">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </div>
    </div>
  </div>
  <p
    class="text-info mt-xxs pr-xlg"
    nz-popover=""
    [nzPopoverTrigger]="this.foodGroup.description.length > 30 ? 'click' : null"
    nzPopoverPlacement="topLeft"
    nzPopoverTitle="Descripción"
    [nzPopoverContent]="moreDetailsTpl"
    appExpandText
    maxCharacters="30"
    onlyTruncate="true"
  >
    {{ foodGroup.description || 'no hay descripción.' }}
  </p>
  <div class="macros d-flex justify-content-between mb-md mt-xlg">
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-chocolatina-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Calorías</p>
      <p class="text-info text-bold">{{ foodGroup?.nutritionalProperties?.energy_kcal?.toFixed(2) || 0 }} kcal</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-sunny-side-up-huevos-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Grasas</p>
      <p class="text-info text-bold">{{ foodGroup?.nutritionalProperties?.totalFat_g?.toFixed(2) || 0 }} g</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-pastel-de-nata-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Carbohidratos</p>
      <p class="text-info text-bold">{{ foodGroup?.nutritionalProperties?.carbohydrate_g?.toFixed(2) || 0 }} g</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-jamon-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Proteínas</p>
      <p class="text-info text-bold">{{ foodGroup?.nutritionalProperties?.protein_g?.toFixed(2) || 0 }} g</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-heno-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Fibra</p>
      <p class="text-info text-bold">{{ foodGroup?.nutritionalProperties?.dietaryFiber_g?.toFixed(2) || 0 }} g</p>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between mt-xlg tw-gap-1">
    <div class="categories">
      <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-etiqueta-de-precio-100.png" alt="">
      <div class="text-subtitle">
        <app-concat-properties *ngIf="foodGroup?.tags?.length> 0" [data]="foodGroup?.tags" subfixSingular="categoría más" subfixPlural="categorías
          más"></app-concat-properties>
      </div>
    </div>
    <nz-tag class="tag" [style.background-color]="'#dfe6e9'" [style.color]="'#333'" *ngIf="foodGroup.sharedClinic">
      Compartido
    </nz-tag>
    <p *ngIf="foodGroup.official" class="delie-verified tw-w-max text-end" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Esta receta es original de Dèliè Nutrición'">
      <img src="/assets/images/icons/verified-delie.png" alt="" class="icon">
      <span class="text">Dèliè oficial</span>
    </p>
  </div>
</div>



<ng-template #moreDetailsTpl>
  <div class="flex tw-max-w-[500px] tw-w-auto" >
    <div class="flex-1">
      {{ foodGroup.description }}
    </div>
  </div>
</ng-template>
